/**
 * Utility functions for formatting data
 */

/**
 * Removes quantity prefix from product names
 * Example: "1x Plato del día" -> "Plato del día"
 * Example: "2x Ensalada César" -> "Ensalada César"
 */
export function cleanProductName(productName: string): string {
  // Remove pattern like "1x ", "2x ", "10x ", etc.
  return productName.replace(/^\d+x\s+/, '')
}

/**
 * Muestra solo las selecciones si el plato tiene opciones entre paréntesis.
 * Si no tiene opciones, muestra el nombre del plato.
 *
 * Ejemplo con opciones: "Plato del dia - Lunes (Arroz Blanco, Batata Frita, Ensalada Mixta)" → "Arroz Blanco, Batata Frita, Ensalada Mixta"
 * Ejemplo sin opciones: "Ensalada César" → "Ensalada César"
 */
export function displayProductName(productName: string): string {
  const cleaned = cleanProductName(productName)

  // Check if there are parentheses with options
  if (!cleaned.includes('(') || !cleaned.includes(')')) {
    return cleaned
  }

  // Extract ALL content inside parentheses
  const allOptions: string[] = []
  const regex = /\(([^)]+)\)/g
  let match
  while ((match = regex.exec(cleaned)) !== null) {
    allOptions.push(match[1].trim())
  }

  if (allOptions.length === 0) {
    return cleaned
  }

  // Join all extracted option groups
  return allOptions.join(', ')
}

/**
 * Format currency to Dominican Peso
 * Shows decimals only when meaningful (e.g. 950 instead of 950.00, but 950.03 stays)
 */
export function formatCurrency(amount: number | string): string {
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount
  return `RD$ ${numAmount.toLocaleString('es-DO', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}`
}

/**
 * Format date to readable format
 */
export function formatDate(date: Date | string): string {
  const dateObj = typeof date === 'string' ? new Date(date) : date
  return dateObj.toLocaleDateString('es-DO', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}

/**
 * Format date and time
 */
export function formatDateTime(date: Date | string): string {
  const dateObj = typeof date === 'string' ? new Date(date) : date
  return dateObj.toLocaleString('es-DO', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
